/**
 * Laengengrenze fuer den Adresszusatz einer Versandadresse (Wohn- oder Lieferadresse).
 *
 * Der engste Empfaenger ist Hartmann: Name 1 bis 4 haben dort je 35 Zeichen, fuer den Zusatz
 * bleiben `PartnerName3` und `PartnerName4`. Ein laengeres Feld liess Hartmann bis 2026-10 die
 * ganze Bestellung abweisen (2026-10-23, Zusatz mit 39 Zeichen). Seitdem verteilt das Backend
 * (`HartmannOrdersXmlBuilder.aufZeilenVerteilen`) den Zusatz an Wortgrenzen auf diese zwei Zeilen
 * und kappt den Rest. Diese Pruefung rechnet dieselbe Verteilung nach und warnt genau dann, wenn
 * dabei etwas abgeschnitten wird.
 *
 * Bewusst eine Warnung und keine Validierung, aus demselben Grund wie beim Empfaengernamen
 * (`empfaengername-laenge.util.ts`): die Grenze gilt nur fuer einen Teil der Logistiker.
 */
export const ADRESSZUSATZ_ZEILENLAENGE = 35
export const ADRESSZUSATZ_ZEILEN = 2

/** Text der Warnung. Steht hier, damit alle Eingabemasken denselben Satz zeigen. */
export const ADRESSZUSATZ_ZU_LANG_HINWEIS = `Zu lang für den Paketaufkleber. Manche Logistiker drucken davon nur etwa ${ADRESSZUSATZ_ZEILEN * ADRESSZUSATZ_ZEILENLAENGE} Zeichen.`

/**
 * Ob der Adresszusatz beim Logistiker gekuerzt wuerde. Spiegelt die Zeilenverteilung des Backends:
 * Woerter fuellen eine Zeile, solange sie passen, alles nach der letzten Zeile haengt an ihr an.
 */
export function istAdresszusatzZuLang(zusatz: string | null | undefined): boolean {
  const text = zusatz?.trim() ?? ''
  if (!text) {
    return false
  }
  const zeilen: string[] = []
  let zeile = ''
  for (const wort of text.split(/\s+/)) {
    if (!zeile) {
      zeile = wort
    } else if (zeile.length + 1 + wort.length <= ADRESSZUSATZ_ZEILENLAENGE || zeilen.length === ADRESSZUSATZ_ZEILEN - 1) {
      zeile += ' ' + wort
    } else {
      zeilen.push(zeile)
      zeile = wort
    }
  }
  zeilen.push(zeile)
  return zeilen.some((z) => z.length > ADRESSZUSATZ_ZEILENLAENGE)
}
